import { getFormattedHtmlAndIsSafe } from '../../../utils/pro-report-helpers.utils';
import {
  emailDefaultBackgroundColour,
  fullWidthCellStyle,
  tableHeaderColour,
  tableHeaderTextColour,
  tableWidth,
} from '../pro-report-email-styles';

export function Spacer() {
  return (
    <table
      width={tableWidth}
      cellPadding={0}
      cellSpacing={0}
      role="presentation"
    >
      <tr>
        <td height="16" style={{ fontSize: 0, lineHeight: 0 }}>{` `}</td>
      </tr>
    </table>
  );
}

export function ProReportEmailFullWidthTableHeader({
  headerText,
}: {
  headerText: string;
}) {
  return (
    <thead>
      <tr
        style={{
          backgroundColor: tableHeaderColour,
          color: tableHeaderTextColour,
          fontWeight: 'bold',
        }}
      >
        <th
          colSpan={2}
          style={{
            ...fullWidthCellStyle,
          }}
        >
          {headerText}
        </th>
      </tr>
    </thead>
  );
}

export function ProReportEmailFullWidthInfoRow({
  heading,
  content,
  backgroundColor,
}: {
  heading: string;
  content: string;
  backgroundColor?: string | undefined;
}) {
  const { formatted, isSafe } = getFormattedHtmlAndIsSafe(content);
  return (
    <tr
      style={{
        backgroundColor,
      }}
    >
      <td
        colSpan={2}
        style={{
          ...fullWidthCellStyle,
        }}
      >
        <strong>{`${heading} `}</strong>
        {isSafe ? (
          // eslint-disable-next-line react/no-danger
          <span dangerouslySetInnerHTML={{ __html: formatted ?? '' }} />
        ) : (
          formatted
        )}
      </td>
    </tr>
  );
}

ProReportEmailFullWidthInfoRow.defaultProps = {
  backgroundColor: emailDefaultBackgroundColour,
};
